import React from 'react';
import { Icon } from '@iconify/react';
import { useNavigate } from 'react-router-dom';

type QuickAction = {
  label: string;
  icon: string;
  path: string;
};

const ACTIONS: QuickAction[] = [
  {
    label: 'Cari Arena',
    icon: 'ph:magnifying-glass',
    path: '/discovery/arena',
  },
  {
    label: 'Mabar',
    icon: 'ph:users-three',
    path: '/discovery/event',
  },
  {
    label: 'Booking',
    icon: 'ph:calendar-plus',
    path: '/discovery/arena',
  },
  {
    label: 'Komunitas',
    icon: 'ph:users-four',
    path: '/discovery/community',
  },
];

export const QuickActionGrid: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="grid grid-cols-4 gap-2.5 select-none" data-testid="quick-action-grid">
      {ACTIONS.map((item) => (
        <button
          key={item.label}
          type="button"
          onClick={() => navigate(item.path)}
          className="bg-white rounded-xl py-3 px-1.5 flex flex-col items-center justify-center gap-2 shadow-[inset_0_0_0_1px_#E0E6ED] hover:shadow-[inset_0_0_0_1px_#FC480D] active:scale-95 transition-all cursor-pointer"
        >
          <Icon icon={item.icon} className="w-[20px] h-[20px] text-[#FC480D] flex-shrink-0" />
          <span className="text-xs font-medium text-gray-900 text-center leading-tight">
            {item.label}
          </span>
        </button>
      ))}
    </div>
  );
};

export default QuickActionGrid;
